/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'

export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  fetchVendors ({ commit }) {
    commit('SET_USERS', [])
    return new Promise((resolve, reject) => {
      axios
        .get('/api/admin/users/vendor')
        .then(response => {
          commit('SET_USERS', response.data.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchBrides ({ commit }) {
    commit('SET_USERS', [])
    return new Promise((resolve, reject) => {
      axios
        .get('/api/admin/users/bride')
        .then(response => {
          commit('SET_USERS', response.data.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchPartners ({ commit }) {
    commit('SET_USERS', [])
    return new Promise((resolve, reject) => {
      axios
        .get('/api/admin/users/partner')
        .then(response => {
          commit('SET_USERS', response.data.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchPromoters ({ commit }) {
    commit('SET_USERS', [])
    return new Promise((resolve, reject) => {
      axios
        .get('/api/admin/users/promoter')
        .then(response => {
          commit('SET_USERS', response.data.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchSupports ({ commit }) {
    commit('SET_USERS', [])
    return new Promise((resolve, reject) => {
      axios
        .get('/api/admin/users/support')
        .then(response => {
          commit('SET_USERS', response.data.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchAdmins ({ commit }) {
    commit('SET_USERS', [])
    return new Promise((resolve, reject) => {
      axios
        .get('/api/admin/users/admin')
        .then(response => {
          commit('SET_USERS', response.data.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchUser (context, {role, action, userId}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/user-management/user/${role}/${action}/${userId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchCategory (context, categoryId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/admin/settings/categories/${categoryId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchFee () {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/admin/settings/fee/add-details')
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateUser (context, userData) {
    return new Promise((resolve, reject) => {
      axios
        .patch('/api/admin/users/profile/update', userData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteUser ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/admin/users/delete/${userId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  removeRecord ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/user-management/users/${userId}`)
        .then(response => {
          commit('REMOVE_RECORD', userId)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
